(() => {
  if (!document.body.classList.contains('dbe-ci-enabled')) return;
  function init(root = document) {
    // Neutralize large legacy yellow/pink panels while retaining badges and controls.
    const panels = [];
    root.querySelectorAll('#wrapper > [id^="shopify-section-template--"] :is(div,section,article)').forEach(el => {
      const css = getComputedStyle(el);
      const rgb = css.backgroundColor.match(/^rgb\((\d+), (\d+), (\d+)\)$/);
      if (!rgb || css.backgroundImage !== 'none') return;
      const [r,g,b] = rgb.slice(1).map(Number);
      if (r > 220 && g > 175 && b < r - 15 && el.offsetWidth > 260 && el.offsetHeight > 70) panels.push(el);
    });
    panels.forEach(el => el.classList.add('dbe-ci-soft-surface'));
    if (location.pathname === '/pages/kundenstimmen') {
      root.querySelectorAll('[data-section-type="image-carousel"] .item.video').forEach(box => {
        if (box.querySelector('.dbe-review-play')) return;
        const video = box.querySelector('video');
        if (!video) return;
        box.classList.add('dbe-review-video');
        const button = document.createElement('button');
        button.type = 'button'; button.className = 'dbe-review-play';
        button.setAttribute('aria-label', 'Kundenstimme abspielen');
        box.append(button);
        const sync = () => { button.hidden = !video.paused; box.dataset.playing = String(!video.paused); };
        video.addEventListener('play', sync); video.addEventListener('pause', sync); video.addEventListener('ended', sync); sync();
      });
    }
    const empty = root.querySelector('.wishlist-hero-list-no-items-content');
    if (empty && !empty.querySelector('.dbe-wishlist-cta')) {
      const link = document.createElement('a'); link.className = 'dbe-wishlist-cta';
      link.href = '/collections/bestseller-1'; link.textContent = 'Bestseller entdecken'; empty.append(link);
    }
  }
  init();
  // Keep the carousel drag handler from swallowing clicks on the play control.
  ['pointerdown','mousedown','touchstart'].forEach(name => document.addEventListener(name, event => {
    if (event.target instanceof Element && event.target.closest('.dbe-review-play')) event.stopPropagation();
  }, true));
  // Use delegated events because the carousel can rebuild media after initialization.
  document.addEventListener('click', event => {
    const button = event.target.closest('.dbe-review-play');
    if (!button) return;
    event.preventDefault(); event.stopPropagation();
    const video = button.parentElement.querySelector('video');
    if (video) video.play().catch(error => console.warn('Customer video playback:', error.name));
  }, true);
  ['play','pause','ended'].forEach(name => document.addEventListener(name, event => {
    if (!(event.target instanceof HTMLVideoElement)) return;
    const box = event.target.closest('.dbe-review-video');
    if (!box) return;
    const button = box.querySelector('.dbe-review-play');
    if (button) button.hidden = !event.target.paused;
    box.dataset.playing = String(!event.target.paused);
  }, true));
  document.addEventListener('shopify:section:load', () => init());
  // Wishlist Hero mounts asynchronously; observe only its own empty-state host.
  if (location.pathname.includes('/a/wishlist-hero/')) {
    const mount = document.getElementById('wrapper');
    function watchWishlist() {
      const wishlist = document.getElementById('wishlist-hero-shared-list-view');
      if (!wishlist) return false;
      init(wishlist);
      new MutationObserver(() => init(wishlist)).observe(wishlist, {childList:true,subtree:true});
      return true;
    }
    if (mount && !watchWishlist()) {
      const pending = new MutationObserver(() => { if (watchWishlist()) pending.disconnect(); });
      pending.observe(mount, {childList:true,subtree:true});
    }
  }
})();
